import { Helmet } from 'react-helmet-async';
import { buildSiteGraph } from '../../config/seo';

const siteGraph = JSON.stringify(buildSiteGraph());

const GlobalSeoSchemas = () => (
  <Helmet>
    <script type="application/ld+json">{siteGraph}</script>
  </Helmet>
);

export default GlobalSeoSchemas;
